// extracted by mini-css-extract-plugin
export default {"forgot-password":"Student_forgot-password__Gu+3L","title":"Student_title__X-rbw"};